import { createGtag } from 'vue-gtag';
import { Environment, GtagId } from '../adapters/environment-variables';
import { getCurrentInstance } from 'vue';

const gtag = createGtag({
  tagId: GtagId,
  config: {
    id: GtagId,
    params: {
      anonymize_ip: true,
      send_page_view: true
    },
    appName: `Download-${Environment}`,
    pageTrackerScreenviewEnabled: true
  }
});

export default gtag;
